export async function FilterStateQuestions(selectedOption, data) {
    const getRangeByOption = (selectedOption) => {
        const start = 301 + (selectedOption - 1) * 10;
        const end = start + 9;
        return { start, end };
    };
    const { start, end } = getRangeByOption(selectedOption);
    return data.filter((item) => item.id >= start && item.id <= end);
}
